import React from 'react'
import FontFile from '../shared/font-file'


// Caps-only design: lowercase maps to uppercase glyphs inside the font itself,
// so this needs no textTransform entry in font/index.js.
const Word = (props) => {
  return <FontFile
    font={'dolce'}
    topOffset='0.05em'
    multiplier={1}
    {...props}
    borderColor={props.backCol}
  />
}

export default Word
